// extracted by mini-css-extract-plugin
export default {"myProfile":"MyProfile_myProfile__19PyI"};